module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Underdog-2007.4b0d175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Underdog-2007.jpg
// module id = ByuN
// module chunks = 0